import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NotifierService } from 'angular-notifier';

import { RegisterService } from 'src/app/shared/services/register.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  private readonly notifier: NotifierService;
  key: string = '';
  tenant: string = '';
  hide: boolean = true;
  passwordForm: FormGroup;
  public loading: boolean;

  get password(): string {
    return this.passwordForm.value.password;
  }

  get resetPassFormControl() {
    return this.passwordForm.controls;
  }


  constructor(
    notifierService: NotifierService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly registerService: RegisterService,
    private fb: FormBuilder
  ) {
    this.notifier = notifierService;
    this.passwordForm = fb.group({
      password: ['', [
        Validators.required,
        Validators.minLength(6),
        Validators.maxLength(100)
      ]],
    });
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      this.key = params?.key;
    });

    this.route.paramMap.subscribe((params) => {
      const result = params.get('tenant');

      if (result) this.tenant = params.get('tenant');
    });
  }

  resetPassword() {
    this.loading = true;
    this.registerService
      .resetPassword(this.key, this.password)
      .subscribe({
        next: (resetResult) => {
          this.notifier.notify('success', 'Senha redefinida com sucesso!');
          this.loading = false;
          this.router.navigate([`${this.tenant}/admin/login`]);
        },
        error: (err) => {
          this.notifier.notify(
            'error',
            'A senha é inválida...'
          );
          this.loading = false;
          this.passwordForm.reset();
        },
      }
      );
  }
  goBack() {
    this.router.navigate([`${this.tenant}/admin/login`]);
  }

}
